import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, RefreshCw, Link, Sparkles } from 'lucide-react';
import { InteriorSlide, SlideHeader } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide11Actions({
  index
}: SlideProps) {
  const benefits = [{
    icon: TrendingDown,
    title: 'Lower campaign cost',
    text: '10% discount on adaptations and updates.'
  }, {
    icon: RefreshCw,
    title: 'Better learning loop',
    text: 'Each campaign informs the next.'
  }, {
    icon: Link,
    title: 'Consistent HCP experience',
    text: 'The brand journey feels connected across the year.'
  }, {
    icon: Sparkles,
    title: 'Freshness built in',
    text: 'Planned teaser and trailer updates prevent repetition.'
  }];
  return <InteriorSlide surface data-id="element-279">
      <SlideHeader eyebrow="Why the 12-Month Model Is Recommended" data-id="element-280">
        Recommended: 12 months if Amoxil is already planning monthly campaigns
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-6xl mx-auto w-full" data-id="element-281">
        <div className="flex-1 space-y-6" data-id="element-282">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="text-[clamp(1.1rem,1.4vw,1.3rem)] text-[var(--muted)] leading-relaxed mb-8" data-id="element-283">
            If GSK Morocco is already planning approximately 12 Amoxil campaigns
            per year, the 12-month model gives the best value and creates a
            complete campaign learning loop.
          </motion.p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-284">
            {benefits.map((benefit, i) => {
            const Icon = benefit.icon;
            return <motion.div key={benefit.title} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.4 + i * 0.1,
              duration: 0.5
            }} className="bg-white p-6 rounded-2xl shadow-sm border border-black/5" data-id="element-285">
                  <div className="h-10 w-10 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--brand)] mb-4" data-id="element-286">
                    <Icon className="h-5 w-5" data-id="element-287" />
                  </div>
                  <h3 className="text-lg font-bold text-[var(--fg)] mb-2" data-id="element-288">
                    {benefit.title}
                  </h3>
                  <p className="text-[var(--muted)] text-sm leading-relaxed" data-id="element-289">
                    {benefit.text}
                  </p>
                </motion.div>;
          })}
          </div>
        </div>

        {/* Loop Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="flex-1 w-full relative aspect-square max-w-md flex items-center justify-center" data-id="element-290">
          <div className="absolute inset-0 rounded-full border-4 border-dashed border-[var(--brand)]/30 animate-[spin_60s_linear_infinite]" data-id="element-291" />

          {[...Array(12)].map((_, i) => {
          const angle = i * 30 * (Math.PI / 180);
          const radius = 45; // percentage
          const top = 50 - Math.cos(angle) * radius;
          const left = 50 + Math.sin(angle) * radius;
          return <div key={i} className="absolute w-8 h-8 bg-white rounded-full border-2 border-[var(--brand)] flex items-center justify-center text-xs font-bold text-[var(--brand)] shadow-sm" style={{
            top: `${top}%`,
            left: `${left}%`,
            transform: 'translate(-50%, -50%)'
          }} data-id="element-292">
                {i + 1}
              </div>;
        })}

          <div className="text-center" data-id="element-293">
            <div className="text-4xl font-bold text-[var(--brand)] mb-1" data-id="element-294">
              12
            </div>
            <div className="text-sm font-bold text-[var(--muted)] uppercase tracking-widest" data-id="element-295">
              Months
            </div>
          </div>
        </motion.div>
      </div>
    </InteriorSlide>;
}